import $ from "jquery";
import Api from "./api";
import Logger from "./../common/logger";

const Phone = (($) => {
  const Default = {
    countryCode: "+1",
    delimiter: "-",
    format: null,
  };

  class Phone {
    constructor(element, config, profile = null) {
      this._id = "ion_amp_phone_" + new Date().getTime();
      this._element = element;
      this._profile = profile;
      this._config = {
        ...Default,
        ...$(this._element).data(),
        ...config,
      };

      if (!profile) {
        this.load();
      } else {
        this.render();
      }
    }

    getConfig(name, defaultValue = null) {
      if (this._config[name]) {
        return this._config[name];
      }
      return defaultValue;
    }

    getID() {
      return this._id;
    }

    load() {
      const self = this;

      if (!this._config.name) {
        Logger.warn("The Name was not supplied to the AMP Call Plugin");
        return;
      }

      Api.getTrackingNumberProfile(this._config.name)
        .done((response) => {
          this._profile = response;
          this.render();
        })
        .fail(() => {
          Logger.error("Failed to Load Tracking Number Profile");
        });
    }

    render() {
      if (!this._profile.trackingNumber) {
        return;
      }
      const delimiter = this.getConfig("delimiter");
      const countryCode = this.getConfig("countryCode");
      const regex = this.getConfig("regex", "(\\d{3})(\\d{3})(\\d{4})");

      const format = this.getConfig(
        "format",
        "$1" + delimiter + "$2" + delimiter + "$3"
      );

      const re = new RegExp(regex);
      const text = this._profile.trackingNumber.replace(re, format);

      var html = "";

      if (this.getConfig("link") == 1) {
        html = `<a class="tel" href="tel:${countryCode}${this._profile.trackingNumber}">${text}</a>`;
      } else {
        html = text;
      }

      $(this._element).html(html);
      $(".ion-amp-phone-number").html(html);
    }
  }

  // Data API
  $("[data-ion='phone']").each(function (index, element) {
    const $element = $(element);
    let data = $element.data("ion.phone]");

    if (!data) {
      data = new Phone(element);
      $element.data("ion.phone", data);
    }

    if (typeof config === "string") {
      if (typeof data[config] === "undefined") {
        throw new TypeError(`No method named "${config}"`);
      }
      data[config]();
    }
  });

  return Phone;
})($);

export default Phone;
